<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Kỳ" :options="category_sKY" :initialValue="modelSearch.idKy"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(e) => { modelSearch.idKy = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Phường/Xã" :options="category_PHUONGXA"
                                :initialValue="modelSearch.phuongXaId" :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(e) => { modelSearch.phuongXaId = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Hiển thị trên cổng" :options="category_ENABLED"
                                :initialValue="modelSearch.enabled" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false"
                                @onChange="(e) => { modelSearch.enabled = e; handlePageChange(1) }" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="currentSearchType == typeDataList.CURRENT_LIST.id">{{ $t('labels.currentList') }}</b>
                        <b v-if="currentSearchType == typeDataList.DELETED_LIST.id">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <TheSwapButton v-model="currentSearchType" @button-clicked="handlePageChange(1)" />
                        <button type="button" class="btn btn-tool" data-toggle="dropdown" :title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.RESTORE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.RESTORE] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.DELETE_TEMP" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE_TEMP] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.DELETE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE] :isDivider="true">
                                    </TheButtonInDropdown>

                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.ON_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.ON_ENABLED] :isDivider="false">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.OFF_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.OFF_ENABLED] :isDivider="true">
                                    </TheButtonInDropdown>
                                </div>
                            </div>
                        </button>
                        <TheCreateButton :onClickParent="() => { detail(null, 'create') }" />
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th style="width:5%">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                    @click="selectAllRows($event)">
                                                <label for="checkboxAll" class="custom-control-label"></label>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="cursor col" style="width:5%" @click="handleSortChange('thethaoPhongtraoId')" title="Sắp xếp theo ID">
                                        ID
                                        <span v-if="sortBy == 'thethaoPhongtraoId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col-2 cursor" @click="handleSortChange('tenPhuongXa')" tilte="Sắp xếp theo tên phường xã">
                                        Phường xã
                                        <span v-if="sortBy == 'tenPhuongXa'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col-2 cursor" @click="handleSortChange('tenKy')" tilte="Sắp xếp theo tên kỳ">
                                        Kỳ
                                        <span v-if="sortBy == 'tenKy'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1">Tỷ lệ người luyện tập TDTT</th>
                                    <th class="col-1">Tỷ lệ gia đình thể thao</th>
                                    <th class="col-1">Số CLB TDTT</th>
                                    <th class="col-1">Số lớp phổ cập bơi</th>
                                    <th class="col-1">Số trẻ em phổ cập bơi</th>

                                    <th class="col-1">Hiển thị trên cổng</th>
                                    <th class="col-1 sticky-action">Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td @click="selectRow(item.thethaoPhongtraoId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span v-if="(csList_Navigate.csList.includes(item.thethaoPhongtraoId))" class="text-primary">&check;</span>
                                            <span v-else>&nbsp;</span>
                                        </div>
                                    </td>
                                    <td>{{ item.thethaoPhongtraoId }}</td>
                                    <td>{{ item.tenPhuongXa }}</td>
                                    <td>{{ item.tenKy }}</td>
                                    <td>{{ item.tyLeNguoiLuyentap }}</td>
                                    <td>{{ item.tyLeGiaDinhTheThao }}</td>
                                    <td>{{ item.soClbTdtt }}</td>
                                    <td>{{ item.soLopPhoCapBoi }}</td>
                                    <td>{{ item.soTreEmPhoCapBoi }}</td>
                                    <td>
                                        <TheSwitchInTable 
                                        :placeholder="'Thay đổi hiển thị trên cổng '"
                                        v-model:initialValue="item.enabled" 
                                        :isReadOnly="currentSearchType == typeDataList.DELETED_LIST.id"
                                        :onChange="(e) => { navigateEnabledChange(item.thethaoPhongtraoId, e.target.checked) }"
                                        ></TheSwitchInTable>
                                    </td>
                                    <td class="sticky-action">
                                        <TheButtonInTable
                                            v-model="tableButton.VIEWDETAIL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DETAIL]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.EDIT" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.UPDATE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.DELETE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE_TEMP]">
                                        </TheButtonInTable>
                                        
                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.DELETE_REAL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.RESTORE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.RESTORE]">
                                        </TheButtonInTable>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <TheCRUDFrameModal ref="modalCRUDRef" idModal="crudModal" dialogClass=" modal-lg" :headerTitle="title"
        :displaySubmit="loadingSubmit" :onSubmit="handleSubmit" :titleSubmit="title" :styleButton="styleButton"
        v-model:showModalFlag="isShowModal.CRUDModal">
        <div class="row">
            <div class="col-md-4">
                <TheSelect title="Phường xã" :options="category_PHUONGXA"
                    :initialValue="model.phuongXaId" :error="errors.phuongXaId"
                    :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true"
                    :isRequire="true" @onChange="(e) => { model.phuongXaId = e }"
                    :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheSelect title="Kỳ" :options="category_cKY"
                    :initialValue="model.idKy" :error="errors.idKy"
                    :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true"
                    :isRequire="true" @onChange="(e) => { model.idKy = e }"
                    :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheInputText title="Số CLB TDTT" placeholder="Nhập số CLB TDTT"
                    :initialValue="model.soClbTdtt" v-model="model.soClbTdtt" :error="errors.soClbTdtt"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <TheInputText title="Số người luyện tập" placeholder="Nhập số người luyện tập"
                    :initialValue="model.soNguoiLuyenTap" v-model="model.soNguoiLuyenTap" :error="errors.soNguoiLuyenTap"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-3">
                <TheInputText title="Tỷ lệ người luyện tập" placeholder="Nhập tỷ lệ người luyện tập" :initialValue="model.tyLeNguoiLuyentap"
                    v-model="model.tyLeNguoiLuyentap" :error="errors.tyLeNguoiLuyentap" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-3">
                <TheInputText title="Số gia đình thể thao " placeholder="Nhập số gia đình thể thao"
                    :initialValue="model.soGiaDinhTheThao" v-model="model.soGiaDinhTheThao" :error="errors.soGiaDinhTheThao"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-3">
                <TheInputText title="Tỷ lệ gia đình thể thao" placeholder="Nhập tỷ lệ gia đình thể thao"
                    :initialValue="model.tyLeGiaDinhTheThao" v-model="model.tyLeGiaDinhTheThao" :error="errors.tyLeGiaDinhTheThao"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <TheInputText title="Số lớp phổ cập bơi" placeholder="Nhập số lớp phổ cập bơi"
                    :initialValue="model.soLopPhoCapBoi" v-model="model.soLopPhoCapBoi" :error="errors.soLopPhoCapBoi"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-3">
                <TheInputText title="Số trẻ em phổ cập bơi" placeholder="Nhập số trẻ em phổ cập bơi"
                    :initialValue="model.soTreEmPhoCapBoi" v-model="model.soTreEmPhoCapBoi" :error="errors.soTreEmPhoCapBoi"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-3">
                <TheInputText title="Số giải quốc gia đăng cai" placeholder="Nhập số giải quốc gia đăng cai"
                    :initialValue="model.dangCaiGiaiQuocGia" v-model="model.dangCaiGiaiQuocGia" :error="errors.dangCaiGiaiQuocGia"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-3">
                <TheInputText title="Số giải khu vực đăng cai" placeholder="Nhập số giải khu vực đăng cai"
                    :initialValue="model.dangCaiGiaiKhuVuc" v-model="model.dangCaiGiaiKhuVuc" :error="errors.dangCaiGiaiKhuVuc"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false"
                    :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <TheInputText title="Ghi chú" placeholder="Nhập ghi chú"
                    :initialValue="model.ghiChu" v-model="model.ghiChu" :error="errors.ghiChu"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="true"
                    :key="tempKey" />
            </div>
        </div>
        <div class="row">

            <div class="col-md-6">
                <TheSwitchButton  title="Hiển thị trên cổng" placeholder="Chọn hiển thị trên cổng" :isReadOnly="isReadOnly" :isRequire=false :key="tempKey" :error="''" v-model:initialValue="model.enabled"> </TheSwitchButton>
            </div>
        </div>
    </TheCRUDFrameModal>

    <TheDetailFrameModal ref="modalDetailRef" idModal="detailModal" dialogClass=" modal-lg"
        :headerTitle="'Chi tiết'" v-model:showModalFlag="isShowModal.detailModal">
        <div class="row" v-if="modelRec">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <div>
                    <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin chung:</b>
                    </p>
                </div>
            </div>
            <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                <p class="text-sm">ID:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.thethaoPhongtraoId
                        }}&nbsp;</b>
                </p>
                <p class="text-sm">Kỳ:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenKy }}&nbsp;</b>
                </p>
                <p class="text-sm">Phường xã:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenPhuongXa
                        }}&nbsp;</b>
                </p>
                <p class="text-sm">Số lớp phổ cập bơi:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soLopPhoCapBoi }}&nbsp;</b>
                </p>
                <p class="text-sm">Số trẻ em phổ cập bơi:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soTreEmPhoCapBoi }}&nbsp;</b>
                </p>
                <p class="text-sm">Số CLB TDTT:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soClbTdtt }}&nbsp;</b>
                </p>
            </div>
            <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                <p class="text-sm">Số người luyện tập TDTT:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soNguoiLuyenTap }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ người luyện tập TDTT:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeNguoiLuyentap }}&nbsp;</b>
                </p>
                <p class="text-sm">Số gia đình thể thao:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soGiaDinhTheThao }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ gia đình thể thao:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeGiaDinhTheThao }}&nbsp;</b>
                </p>
                <p class="text-sm">Số giải quốc gia đăng cai:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.dangCaiGiaiQuocGia }}&nbsp;</b>
                </p>
                <p class="text-sm">Số giải khu vực đăng cai:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.dangCaiGiaiKhuVuc }}&nbsp;</b>
                </p>
            </div>
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <div>
                    <hr />
                    <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin khác:</b>
                    </p>
                </div>
            </div>
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm">Ghi chú:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                </p>
            </div>
            <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                <p class="text-sm">STT:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                </p>
                <p class="text-sm">Hiển thị trên cổng:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                        }}&nbsp;</b>
                </p>
            </div>
        </div>
    </TheDetailFrameModal>
    <TheConfirmDialogModal :title="csList_MapModel.title"
        :confirmLabelButton="csList_MapModel.confirmLabelButton" :onClose="csList_MapModel.onClose"
        :onSubmit="csList_MapModel.onSubmit" :modalContent=csList_MapModel.modalContent
        :isReConfirm=csList_MapModel.isReConfirm :reConfirmMes=csList_MapModel.reConfirmMes
        v-model:showModalFlag="isShowModal.confirmDialogModal"></TheConfirmDialogModal>
    <TheCheckboxConfirmDialogModal :title="csListEnabled_MapModel.title"
        :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton"
        :onClose="csListEnabled_MapModel.onClose" :onSubmit="csListEnabled_MapModel.onSubmit"
        :modalContent=csListEnabled_MapModel.modalContent :key="tempKey"
        :submitArgs="csListEnabled_MapModel.submitArgs" v-model="checkEnable_Memo"
        v-model:showModalFlag="isShowModal.checkBoxConfirmModal">
    </TheCheckboxConfirmDialogModal>



</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import objectDefaultValue from '@/config/object.env'
import tableValue from '@/config/table.env'
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';

import TheSwapButton from '@/components/shareComponents/table/button/TheSwapButton.vue'
import TheCreateButton from '@/components/shareComponents/table/button/TheCreateButton.vue'
import TheButtonInDropdown from '@/components/shareComponents/table/button/TheButtonInDropdown.vue'
import TheButtonInTable from '@/components/shareComponents/table/button/TheButtonInTable.vue'

import TheSwitchButton from '@/components/shareComponents/TheSwitchButton.vue'
import TheDetailFrameModal from '@/components/shareComponents/modal/TheDetailFrameModal.vue'
import TheCRUDFrameModal from '@/components/shareComponents/modal/TheCRUDFrameModal.vue'
import TheCheckboxConfirmDialogModal from '@/components/shareComponents/modal/TheCheckboxConfirmDialogModal.vue'
import TheConfirmDialogModal from '@/components/shareComponents/modal/TheConfirmDialogModal.vue'

import TheSwitchInTable from '@/components/shareComponents/table/switch/TheSwitchInTable.vue'

import { phongTraoTheThaoVHModel } from '@/models/thethao/phongTraoTheThaoVH.model'
import { tableInteractiveModel } from '@/models/general/tableInteractive.model'

export default {
    name: "ThePhongTraoTheThaoVH",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheSwapButton,
        TheCreateButton,
        TheButtonInDropdown,
        TheButtonInTable,
        TheDetailFrameModal,
        TheCRUDFrameModal,
        TheCheckboxConfirmDialogModal,
        TheConfirmDialogModal,
        TheSwitchButton,
        TheSwitchInTable,

    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],
            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            modelRec: phongTraoTheThaoVHModel.newModel(),
            model: phongTraoTheThaoVHModel.newFEModel(),
            errors: phongTraoTheThaoVHModel.errors(),
            modelSearch: phongTraoTheThaoVHModel.newPagingSearchModel(),

            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            acceptImageType: objectDefaultValue.ACCEPT_TYPE_IMG,
            acceptTypeExcel: objectDefaultValue.ACCEPT_TYPE_EXCEL,

            cEnable_Item: null,
            checkEnable_Memo: false,

            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,
            category_PHUONGXA: [],
            category_cKY: [],
            category_sKY: [],
            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            isShowModal: {
                CRUDModal: false,
                detailModal: false,
                checkBoxConfirmModal: false,
                confirmDialogModal: false,
            },
            loadingSubmit: false,
            tempKey: common.randomString(10),

            currentSearchType: objectDefaultValue.TYPEDATA_LIST.CURRENT_LIST.id,
            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,
            typeDataList: objectDefaultValue.TYPEDATA_LIST,
            tableButton: objectDefaultValue.TABLEBUTTON,

        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber', 'validateFloat'],),
        ...mapActions('handleData2', ['handleTypeImport', 'handleChangeType', 'formatData']),
        ...mapActions('phongTraoTheThaoVH', ['getPagingPhongTraoTheThaoVH', 'getDetailPhongTraoTheThaoVH', 'getCustomDetailPhongTraoTheThaoVH', 'checkExistPhongTraoTheThaoVH', 'createPhongTraoTheThaoVH', 'updatePhongTraoTheThaoVH', 'deletePhongTraoTheThaoVH', 'restorePhongTraoTheThaoVH', 'handleListPhongTraoTheThaoVH', 'setEnabledPhongTraoTheThaoVH', 'exportExcelPhongTraoTheThaoVH', 'getMapInfoPhongTraoTheThaoVH', 'importExcelPhongTraoTheThaoVH']),
        ...mapActions('dmKy', ['getBasicDMKy']),
        ...mapActions('phuongXa', ['getsPhuongXa']),

        async setup() {
            let header = 'Danh sách tổng hợp thông tin phong trào thể thao'
            this.setupHeader({ header })
        },

        async initialize() {
            this.category_PHUONGXA = await this.getCategory_PhuongXa()
        },
        //#region TableNavigation
        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },
        async showEnabledConfirmModal() {
            this.csListEnabled_MapModel = {
                title: "XÁC NHẬN",
                confirmLabelButton: "Xác nhận",
                onClose: this.closeConfirmEnabledChange,
                onSubmit: this.updateEnabled,
                submitArgs: [2],
                modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
            }
            this.isShowModal.checkBoxConfirmModal = true
        },
        async navigateEnabledChange(id,  value) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                this.updateEnabled()
            }
        },
        async updateEnabled() {
            let model = {
                thethaoPhongtraoId: this.cEnable_Item.id,
                enabled: this.cEnable_Item.enabled
            }
            await this.setEnabledPhongTraoTheThaoVH({ model: model }).then(async resp => {
                if (resp) {
                    this.isShowModal.checkBoxConfirmModal = false
                }
                else {
                    const itemIndex = this.items.findIndex(item => item.thethaoPhongtraoId === this.cEnable_Item.id);
                    if (itemIndex !== -1) {
                        this.items[itemIndex].enabled = !this.items[itemIndex].enabled;

                    } else {
                        await this.getData()
                    }
                }

            });
        },
        async closeConfirmEnabledChange() {
            const itemIndex = this.items.findIndex(item => item.thethaoPhongtraoId === this.cEnable_Item.thethaoPhongtraoId);
            if (itemIndex !== -1) {
                this.items[itemIndex].enabled = !this.items[itemIndex].enabled;
            } else {
                await this.getData()
            }
            this.isShowModal.checkBoxConfirmModal = false
        },
        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },
        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },
        async unSelectAllRows() {
            this.csList_Navigate.csList = []
            document.getElementById("checkboxAll").checked = false
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.thethaoPhongtraoId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },
        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
            this.modelSearch.enabled = await this.handleChangeType({ input: this.modelSearch.enabled, typeChange: objectDefaultValue.changeTypeData.STRING_TO_BOOLEAN })
        },
        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            await this.standardizationFilter()
            await this.unSelectAllRows()
            this.category_sKY = await this.getCategory_Ky(1)
            await this.getPagingPhongTraoTheThaoVH({ params: this.modelSearch, type: this.currentSearchType }).then(res => {
                // List data
                this.items = res.data
                this.totalRow = res.totalRow
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },
        //#endregion TableNavigation

        //#region CRUD
        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.errors = phongTraoTheThaoVHModel.errors()
            this.loadingSubmit = false
            this.category_cKY = await this.getCategory_Ky()
            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    thethaoPhongtraoId: item.thethaoPhongtraoId
                }
                await this.getDetailPhongTraoTheThaoVH({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = phongTraoTheThaoVHModel.newModel()
                        this.modelRec = resp
                        this.model = phongTraoTheThaoVHModel.parseModeltoFEModel(this.modelRec)

                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    thethaoPhongtraoId: item.thethaoPhongtraoId
                }
                await this.getDetailPhongTraoTheThaoVH({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = phongTraoTheThaoVHModel.newModel()
                        this.modelRec = resp

                    }
                });
                this.tempKey = common.randomString(10)
                this.isShowModal.detailModal = true
            }
            else {
                this.model = phongTraoTheThaoVHModel.newFEModel()
                this.isReadOnly = false
                // show popup
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
        },
        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistPhongTraoTheThaoVH({ params: params })
            return res.data
        },
        async validate(model) {
            let isvalid = true
            this.errors = phongTraoTheThaoVHModel.errors()
            if (!await this.validateRequired(model.idKy)) {
                this.errors.idKy = "Chọn kỳ"
                isvalid = false
            }

            if (!await this.validateRequired(model.phuongXaId)) {
                this.errors.phuongXaId = "Chọn phường xã"
                isvalid = false
            }

            if (!await this.validateNumber(model.soClbTdtt)) {
                this.errors.soClbTdtt = "Số CLB TDTT phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateNumber(model.soNguoiLuyenTap)) {
                this.errors.soNguoiLuyenTap = "Số người luyện tập TDTT phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyLeNguoiLuyentap)) {
                this.errors.tyLeNguoiLuyentap = "Tỷ lệ người luyện tập TDTT phải là kiểu số thực"
                isvalid = false
            }
            if (!await this.validateNumber(model.soGiaDinhTheThao)) {
                this.errors.soGiaDinhTheThao = "Số gia đình thể thao phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateFloat(model.tyLeGiaDinhTheThao)) {
                this.errors.tyLeGiaDinhTheThao = "Tỷ lệ luyện tập TDTT phải là kiểu số thực"
                isvalid = false
            }
            if (!await this.validateNumber(model.soLopPhoCapBoi)) {
                this.errors.soLopPhoCapBoi = "Số lớp phổ cập bơi phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateNumber(model.soTreEmPhoCapBoi)) {
                this.errors.soTreEmPhoCapBoi = "Số trẻ em phổ cập bơi phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateNumber(model.dangCaiGiaiQuocGia)) {
                this.errors.dangCaiGiaiQuocGia = "Số giải quốc gia đăng cai phải là kiểu số nguyên"
                isvalid = false
            }
            if (!await this.validateNumber(model.dangCaiGiaiKhuVuc)) {
                this.errors.dangCaiGiaiKhuVuc = "Số giải khu vực đăng cai phải là kiểu số nguyên"
                isvalid = false
            }
            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = phongTraoTheThaoVHModel.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.thethaoPhongtraoId = FEmodel.thethaoPhongtraoId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.thethaoPhongtraoId = FEmodel.thethaoPhongtraoId
                sendModel.quanHuyenId = config.QUANHUYEN_SITEID
                sendModel.phuongXaId = FEmodel.phuongXaId
                sendModel.soNguoiLuyenTap = FEmodel.soNguoiLuyenTap
                sendModel.tyLeNguoiLuyentap = FEmodel.tyLeNguoiLuyentap
                sendModel.soGiaDinhTheThao = FEmodel.soGiaDinhTheThao
                sendModel.tyLeGiaDinhTheThao = FEmodel.tyLeGiaDinhTheThao
                sendModel.soClbTdtt = FEmodel.soClbTdtt
                sendModel.soLopPhoCapBoi = FEmodel.soLopPhoCapBoi
                sendModel.soTreEmPhoCapBoi = FEmodel.soTreEmPhoCapBoi
                sendModel.dangCaiGiaiQuocGia = FEmodel.dangCaiGiaiQuocGia
                sendModel.dangCaiGiaiKhuVuc = FEmodel.dangCaiGiaiKhuVuc
                sendModel.idKy = FEmodel.idKy
                sendModel.ghiChu = FEmodel.ghiChu
                sendModel.enabled = FEmodel.enabled ? FEmodel.enabled : false
            }
            return sendModel
        },
        async handleSubmit() {
            if (this.code === this.navigateCode.DELETE) {
                this.csList_MapModel = {
                    title: this.$t('labels.confirmDelete'),
                    confirmLabelButton: this.$t('buttons.confirm'),
                    onClose: null,
                    onSubmit: this.onSubmit,
                    modalContent: "<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>",
                }
                this.isShowModal.confirmDialogModal = true
            }
            else {
                await this.onSubmit()
            }
        },
        async onSubmit() {
            this.loadingSubmit = true
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        res = await this.createPhongTraoTheThaoVH({ model: sendModel })
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        res = await this.updatePhongTraoTheThaoVH({ model: sendModel })
                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deletePhongTraoTheThaoVH({ model: sendModel, type: this.currentSearchType })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deletePhongTraoTheThaoVH({ model: sendModel, type: this.currentSearchType })
                    if (res) this.isShowModal.confirmDialogModal = false
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restorePhongTraoTheThaoVH({ model: sendModel })
                    break
                default:
            }
            if (res) {
                this.isShowModal.CRUDModal = false
                await this.getData()
            }

            this.loadingSubmit = false
        },
        //#endregion CRUD
        //#region ListNavigation
        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                let tempReConfirmMes = code == this.navigateCode.DELETE ?"<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>những dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>" : null
                this.csList_MapModel = {
                    isReConfirm: code == this.navigateCode.DELETE ? true : false,
                    reConfirmMes: tempReConfirmMes,
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: null,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.isShowModal.confirmDialogModal = true
            }
        },

        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            if (code == this.navigateCode.OFF_ENABLED) {
                modelSend.model.enabled = false
            }
            if (code == this.navigateCode.ON_ENABLED) {
                modelSend.model.enabled = true
            }
            let res = null
            if (code == objectDefaultValue.NAVIGATECODE_VALUE.DELETE) {
                res = await this.handleListPhongTraoTheThaoVH(modelSend)
            }
            else {
                res = await this.handleListPhongTraoTheThaoVH(modelSend)
            }
            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.isShowModal.confirmDialogModal = false
            }
        },
        //#endregion ListNavigation
        async getCategory_PhuongXa() {
            let params = {
                quanHuyenId: config.QUANHUYEN_SITEID
            }
            let res = await this.getsPhuongXa({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].phuongXaId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },

        async getCategory_Ky(filterNumber = 0) {
            let params = {
                tableName: tableValue.TT_PHONGTRAOTHETHAO,
                loaiKy: 'Y'
            }
            params.filter = filterNumber
            let res = await this.getBasicDMKy({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].idKy,
                            name: res[i].tenKy
                        }
                    )
                }
                return handleRes
            }

            return res
        },
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }
}
</script>
<style>
</style>
